module.exports = __webpack_public_path__ + "img/主页3.2631536f.jpg";